var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10322_13039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44482 14.5095L12.5868 19.6515C16.8455 18.5158 20 14.6357 20 9.9985C20 9.90386 20 9.80922 20 9.71458L15.9622 5.99219L7.44482 14.5095Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2521 12.2441C10.6938 12.6857 10.6938 13.4428 10.2521 13.8845L9.33729 14.7993C8.89565 15.2409 8.13855 15.2409 7.69691 14.7993L3.69061 10.7614C3.24896 10.3198 3.24896 9.5627 3.69061 9.12106L4.60543 8.20623C5.04707 7.76459 5.80417 7.76459 6.24581 8.20623L10.2521 12.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7537 5.26873C14.1954 4.82709 14.9525 4.82709 15.3941 5.26873L16.3089 6.18356C16.7506 6.6252 16.7506 7.38229 16.3089 7.82393L9.36886 14.7325C8.92722 15.1741 8.17012 15.1741 7.72848 14.7325L6.81365 13.8176C6.37201 13.376 6.37201 12.6189 6.81365 12.1772L13.7537 5.26873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10322_13039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked_icon.98343c88e254fdca52360cd69af874b4.svg";
export { ForwardRef as ReactComponent };